export default "__VITE_ASSET__b7fca6e7__"